import { drugCodeAllowedValueRegex, drugNameAllowedValueRegex } from 'common/constants/regex';

import { isManualProductIdCodeValid } from './manualProductId';

export const DRUG_CODE_FORMAT_HINT = 'Must be a letter followed by 2 letters or digits';

// Every reason a catalog create stays disabled, in on-screen order. The New Catalog
// and Add to Catalog dialogs derive their submit state from this list, so the
// button and the message explaining it cannot disagree.
export const listCatalogSubmitBlockers = ({
  drugName,
  drugCode,
  isDrugCodeTaken,
  isLoadingCodes,
  variants,
}) => {
  const blockers = [];
  const trimmedDrugName = drugName.trim();
  const trimmedDrugCode = drugCode.trim();

  if (!trimmedDrugName) {
    blockers.push('Drug Name is required');
  } else if (!drugNameAllowedValueRegex.test(drugName)) {
    blockers.push('Drug Name has characters that are not allowed');
  }

  // The code is derived from the name, so it is only judged once there is a name.
  if (isLoadingCodes) {
    blockers.push('Checking existing drug codes');
  } else if (trimmedDrugName) {
    if (!trimmedDrugCode) {
      blockers.push('Drug Code is required');
    } else if (!drugCodeAllowedValueRegex.test(trimmedDrugCode)) {
      blockers.push('Drug Code must be a letter followed by 2 letters or digits');
    } else if (isDrugCodeTaken) {
      blockers.push('Drug Code is already used');
    }
  }

  variants.forEach((variant, index) => {
    const { strength, formAlias, manualProductIdCode, needsManualProductId } = variant;
    const variantLabel = variants.length > 1 ? ` (Variant ${index + 1})` : '';

    if (!strength.trim()) blockers.push(`Strength is required${variantLabel}`);
    if (!formAlias) blockers.push(`Form is required${variantLabel}`);
    // POM-6514: required on a variant whose generation failed -- resubmitting it blank would fail
    // the same way -- and unique, against the catalog and the rest of the request.
    if (needsManualProductId) {
      if (!manualProductIdCode) {
        blockers.push(`Product ID is required${variantLabel}`);
      } else if (!isManualProductIdCodeValid(manualProductIdCode)) {
        blockers.push(`Product ID is incomplete${variantLabel}`);
      } else if (variant.manualProductIdConflict) {
        blockers.push(`Product ID must be unique${variantLabel}`);
      }
    }
  });

  return blockers;
};
